import { SortDirection } from '@silverfort/sf-components';

export enum SmartPolicyAction {
    ALTER_AFTER = '1',
    BLOCK_AFTER = '2'
}

export type SmartPolicy = {
    id: number;
    company_id: number;
    name: string;
    alter_after: number;
    block_after: number;
    activated_action: SmartPolicyAction[];
    update_time: Date;
    created_time: Date;
    send_to_siem: boolean;
    in_scope_sa: number;
    last_run?: Date;
    description: string;
    is_deleted: boolean;
    delete_date?: Date;
    protect_risk_indicators: string[];
    is_limit_activities: boolean;
    days_limit_activities: number;
};

export type SmartPolicyBeforeFormatting = Omit<SmartPolicy, 'update_time' | 'created_time' | 'last_run'> & {
    update_time: string;
    created_time: string;
    last_run?: string;
};

export type SmartPolicyEntity = {
    guid: string;
    type: number;
    excluded: boolean;
};

export type SmartPolicyEntityFullData = SmartPolicyEntity & {
    display_name: string;
    domain_name: string;
};

export type SmartPolicyWithEntities = SmartPolicy & {
    entities: SmartPolicyEntity[];
};

export type SmartPolicyWithEntitiesFullData = SmartPolicy & {
    entities: SmartPolicyEntityFullData[];
};

export type SmartPolicyBeforeFormattingWithFormattedEntities = SmartPolicyBeforeFormatting & {
    entities: SmartPolicyEntityFullData[];
};

export type SmartPolicyConfig = {
    maxSmartPolicies: number;
    minDaysToActivate: number;
    maxDaysToActivate: number;
    defaultDayActivateAlter: number;
    defaultDayActivateBlock: number;
    defaultDaysLimitActivities: number;
    minDaysToLimitActivities: number;
    maxDaysToLimitActivities: number;
};

export type OrderState = {
    orderByField: keyof SmartPolicyWithEntitiesFullData;
    orderDirection: SortDirection;
};

export enum SmartPolicyCreationFlow {
    MANUAL = 'manual',
    BULK = 'bulk'
}
